export function accordionToggle(triggerClass, parentClass, bodyClass, indicatorClass) {
    const accordionTrigger = $(triggerClass);

    if (!accordionTrigger.length) return;

    accordionTrigger.each((index, trigger) => {
        const $trigger = $(trigger);
        const $parent = $trigger.closest(parentClass);
        const $body = $parent.find(bodyClass);
        const $indicator = $trigger.parent().find(indicatorClass);

        $trigger.on('click', () => {
            $indicator.toggleClass('active');
            $body.slideToggle("slow");
        });
    });
}
